import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { getToken } from "../../../../Utils/Common";

function PhraseList() {
  const { chapter_id } = useParams();
  const token = getToken();
  const [phrase, setPhrase] = useState([]);
  const [error, setError] = useState([]);
  const [loader, setLoader] = useState(true);
  const [sucessMessage, setsucessMessage] = useState("");
  // console.log(book_id);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const back = () => {
    // console.log("d");
    navigate(-1);
  };

  useEffect(() => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}v1/admin/phrase?chapter_id=${chapter_id}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        chapter_id: chapter_id,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          // console.log(response.data.data);
          setData(response.data.data);
          setPhrase(response.data.data.phrase);
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        // console.log(error.response);
        if (error.response.status === 404) {
          setErrorMessage(error.response.data.message);
        }
      });
  }, []);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure")) {
      axios({
        method: "delete",
        url: `${process.env.REACT_APP_API_URL}v1/admin/phrase/${id}`,
        // url: `http://autoexpress.pk/lingonovel/lingnovel-api/public/api/v1/admin/create-book`,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          // console.log(response);
          if (response.status === 200) {
            setsucessMessage(response.data.message);
            // console.log(response);
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            // console.log(error.response);
            setError(error.response.data.message);
          } else if (error.response.status === 500) {
            // console.log(error.response);
            setError("Something went wrong. Please try again later.");
          } else {
            // console.log(error.response);
            setError("Something went wrong. Please try again later.");
          }
          // console.log(error.response);
        });
    }
  };

  // console.log(data);

  return (
    <div className="container" style={{ marginTop: "140px" }}>
      <div>
        {/* <button className="btn btn-lg btn-primary" onClick={() => navigate(-1)}>
        go back
      </button> */}

        <div className="card mb-5 mb-xl-8">
          <div className="d-flex justify-content-center">
            <div
              className={loader === true ? "spinner-border" : ""}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          {/*begin::Header*/}
          <div className="card-header border-0 pt-5">
            <h3 className="card-title align-items-start flex-column">
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                {/* <li className="breadcrumb-item">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li> */}

                <li
                  className="breadcrumb-item text-muted"
                  style={{ fontSize: "15px" }}
                >
                  <Link to={`/admin/books`}>Books</Link>
                </li>

                <li className="breadcrumb-item" style={{ fontSize: "15px" }}>
                  <span className="bullet bg-gray-300 w-5px h-2px" />
                </li>

                <li
                  className="breadcrumb-item text-muted"
                  style={{ fontSize: "15px" }}
                >
                  <Link to="#" onClick={back}>
                    {" "}
                    Chapters{" "}
                  </Link>
                </li>

                <li className="breadcrumb-item" style={{ fontSize: "15px" }}>
                  <span className="bullet bg-gray-300 w-5px h-2px" />
                </li>

                <li
                  className="breadcrumb-item text-dark"
                  style={{ fontSize: "15px" }}
                >
                  {" "}
                  {data.title}{" "}
                </li>

                <li className="breadcrumb-item" style={{ fontSize: "15px" }}>
                  <span className="bullet bg-gray-300 w-5px h-2px" />
                </li>

                <li
                  className="breadcrumb-item text-dark"
                  style={{ fontSize: "15px" }}
                >
                  {" "}
                  Phrase List{" "}
                </li>
              </ul>

              <span
                className="card-label fw-bolder fs-3 mb-1"
                style={{ marginTop: "50px" }}
              >
                Phrase List
              </span>
              {/* <span className="text-muted mt-1 fw-bold fs-7">Over 500 orders</span> */}
            </h3>
            <p style={{ color: "red", fontSize: "20px" }}>{sucessMessage}</p>
            <div className="card-toolbar">
              <Link
                to={`/admin/chapter/phrase/create/` + chapter_id}
                className="btn btn-sm btn-light-primary"
              >
                Add Phrase
              </Link>
              <div
                className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px"
                data-kt-menu="true"
              ></div>
              {/*end::Menu 2*/}
              {/*end::Menu*/}
            </div>
          </div>
          {/*end::Header*/}
          {/*begin::Body*/}
          <div className="card-body py-3">
            {/*begin::Table container*/}
            <div className="table-responsive">
              {/*begin::Table*/}
              <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                {/*begin::Table head*/}
                <thead>
                  <tr className="fw-bolder text-muted">
                    <th className="w-25px">
                      <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                    </th>
                    <th className="min-w-150px">Phrase</th>
                    <th className="min-w-140px"> Dictionary </th>
                    <th className="min-w-120px">Phrase Audio</th>
                    {/* <th className="min-w-100px"> Sample Chapter </th> */}
                    <th className="min-w-100px">Actions</th>
                  </tr>
                </thead>
                {/*end::Table head*/}
                {/*begin::Table body*/}
                <tbody>
                  {phrase.length > 0 ? (
                    phrase.map((data, index) => (
                      <tr key={index}>
                        <td>
                          <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                        </td>

                        <td>
                          <div className="d-flex align-items-center">
                            {/*begin::Avatar*/}
                            <div className="symbol symbol-45px me-5">
                              {data.phrase}
                            </div>
                            {/*end::Avatar*/}
                            {/*begin::Name*/}
                            <div className="d-flex justify-content-start flex-column"></div>
                            {/*end::Name*/}
                          </div>
                        </td>

                        <td className="text-dark fw-bolder fs-6">
                          {data.dictionary}
                        </td>
                        {/* <td className="text-dark fw-bolder text-hover-primary fs-6">
                          Book Author
                        </td> */}
                        {/* <td className="text-dark fw-bolder text-hover-primary fs-6">
                          Book Narrated
                        </td> */}
                        <td className="text-dark fw-bolder text-hover-primary fs-6">
                          {/* {data.line_audio} */}

                          <audio controls>
                            <source src={data.line_audio} type="audio/ogg" />
                            <source src={data.line_audio} type="audio/mpeg" />
                          </audio>
                        </td>
                        {/* <td className="text-dark fw-bolder text-hover-primary fs-6">
                          <Link
                            to={`/admin/chapter/phrase/create/${data.id}`}
                            className="btn btn-sm btn-light-primary"
                          >
                            <span className="svg-icon svg-icon-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  opacity="0.5"
                                  x="11.364"
                                  y="20.364"
                                  width="16"
                                  height="2"
                                  rx="1"
                                  transform="rotate(-90 11.364 20.364)"
                                  fill="black"
                                ></rect>
                                <rect
                                  x="4.36396"
                                  y="11.364"
                                  width="16"
                                  height="2"
                                  rx="1"
                                  fill="black"
                                ></rect>
                              </svg>
                            </span>
                          </Link>
                        </td> */}
                        <td>
                          <div className="d-flex justify-content-end flex-shrink-0">
                            {/* <Link
                              to={`/admin/books/chapter/edit`}
                              className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                            >
                             
                              <span className="svg-icon svg-icon-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z"
                                    fill="black"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                              
                            </Link> */}
                            <Link
                              to={`/admin/phrases/edit/${data.id}`}
                              className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                            >
                              {/* begin::Svg Icon | path: icons/duotune/art/art005.svg */}
                              <span className="svg-icon svg-icon-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                              {/* end::Svg Icon */}
                            </Link>
                            <Link
                              to={`#`}
                              className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                              onClick={() => handleDelete(data.id)}
                            >
                              {/* begin::Svg Icon | path: icons/duotune/general/gen027.svg */}
                              <span className="svg-icon svg-icon-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                    fill="black"
                                  />
                                  <path
                                    opacity="0.5"
                                    d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                    fill="black"
                                  />
                                  <path
                                    opacity="0.5"
                                    d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                              {/* end::Svg Icon */}
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        style={{
                          fontSize: "2rem",
                          color: "red",
                          textAlign: "center",
                        }}
                      >
                        {errorMessage}
                      </td>
                    </tr>
                  )}
                </tbody>
                {/*end::Table body*/}
              </table>
              {/*end::Table*/}
            </div>
            {/*end::Table container*/}
          </div>
          {/*begin::Body*/}
        </div>
      </div>
    </div>
  );
}

export default PhraseList;
